import { createContext } from 'react';

/** Direction B (beta only): the place in the studio's top bar where the open view puts its own controls. */
export const StudioBarSlot = createContext<HTMLElement | null>(null);
